import Form from 'mobx-react-form';
import plugins from './plugins';


const fields = {
    cert: {
        label: 'Certificate (Base64)',
        rules: 'string|required',
    },
    appName: {
        label: 'Identifier (Entity ID)',
        rules: 'string|required',
    },
    domain: {
        label: 'Emails domain',
        rules: 'string|required',
    },
    tenant: {
        label: 'Tenant Id',
        rules: 'required|string',
    },
};

class AzureAdForm extends Form {
    constructor(setup, options) {
        super({ fields, ...setup }, { plugins, ...options });
    }
}

export default AzureAdForm;
